import { Component, Input } from '@angular/core';
import { RingState } from '../challenge.model';

@Component({
    selector: 'app-stats-panel',
    templateUrl: './stats-panel.component.html',
    styleUrls: ['./stats-panel.component.scss'],
    standalone: false
})
export class StatsPanelComponent {
  @Input() rings: RingState[] = [];
  @Input() dailyProgress: { complete: number; total: number } = { complete: 0, total: 0 };
  @Input() weeklyProgress: { complete: number; total: number } = { complete: 0, total: 0 };

  get overallStreak(): number {
    return this.rings.reduce((max, r) => Math.max(max, r.streak), 0);
  }

  get dailyPct(): number {
    if (!this.dailyProgress.total) return 0;
    return (this.dailyProgress.complete / this.dailyProgress.total) * 100;
  }

  get weeklyPct(): number {
    if (!this.weeklyProgress.total) return 0;
    return (this.weeklyProgress.complete / this.weeklyProgress.total) * 100;
  }

  trackDotIndex(i: number) { return i; }
}
